import { render } from "./Quiz.vue?vue&type=template&id=35b54e28"
import script from "./Quiz.vue?vue&type=script&lang=js"
export * from "./Quiz.vue?vue&type=script&lang=js"
script.render = render

export default script